import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faShieldCheck, faBolt, faMoneyCheckDollar, faHeadset } from '@fortawesome/pro-solid-svg-icons'

const SidePanel = () => {
  return (
    <div className="merchant-app-right">
      <div className="merchant-app-right-logo">
        Synked<span className="highlight">UP</span> Payments
      </div>

      <div className="merchant-app-right-features">
        <div className="merchant-app-right-feature">
          <div className="merchant-app-right-feature-icon">
            <FontAwesomeIcon icon={faBolt} />
          </div>
          <div className="merchant-app-right-feature-text">
            <strong>Get Paid Faster</strong>
            <span>Send invoices and collect payments directly through SynkedUP.</span>
          </div>
        </div>

        <div className="merchant-app-right-feature">
          <div className="merchant-app-right-feature-icon">
            <FontAwesomeIcon icon={faMoneyCheckDollar} />
          </div>
          <div className="merchant-app-right-feature-text">
            <strong>Competitive Rates</strong>
            <span>Simple, transparent pricing with no hidden fees.</span>
          </div>
        </div>

        <div className="merchant-app-right-feature">
          <div className="merchant-app-right-feature-icon">
            <FontAwesomeIcon icon={faShieldCheck} />
          </div>
          <div className="merchant-app-right-feature-text">
            <strong>Secure & Compliant</strong>
            <span>Bank-level encryption protects your data at every step.</span>
          </div>
        </div>

        <div className="merchant-app-right-feature">
          <div className="merchant-app-right-feature-icon">
            <FontAwesomeIcon icon={faHeadset} />
          </div>
          <div className="merchant-app-right-feature-text">
            <strong>Dedicated Support</strong>
            <span>Our team is here to help you get set up and running.</span>
          </div>
        </div>
      </div>

      <div className="merchant-app-right-secure">
        <FontAwesomeIcon icon={faShieldCheck} />
        Your information is encrypted and secure
      </div>
    </div>
  )
}

export default SidePanel
